import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import RequestPageAccessForm from './RequestPageAccessForm'
import FormDrawerWrapper from '../../../../../../features/components/FormDrawerWrapper'
import SkeletonSingleSectionForm from '../../../../../../features/components/FormDrawerWrapper/Skeletons/SkeletonSingleSectionForm'
import FacebookBusinessManagerMissingWarning from '../../../../../../features/components/warnings/FacebookBusinessManagerMissingWarning'

import useManageDrawer from '../../../../../../hooks/formHooks/useManageDrawer'

import { getSelfAccount, clearSelfAccount } from '../../../../../../modules/actions/selfAccounts'
import { selfAccountSelector, selfAccountWasLoadedSelector } from '../../../../../../modules/selectors/selfAccounts'
import { selectedPartnershipRightsHolderSelfAccountIdSelector } from '../../../../../../modules/selectors/app'

import { REQUEST_FACEBOOK_PAGE_ACCESS } from '../../../../../../constants/forms'

const RequestPageAccess = () => {
  const dispatch = useDispatch()

  const selfAccount = useSelector(selfAccountSelector)
  const selfAccountWasLoaded = useSelector(selfAccountWasLoadedSelector)
  const selectedPartnershipRightsHolderAccountId = useSelector(selectedPartnershipRightsHolderSelfAccountIdSelector)

  const { facebook_bm_id: facebookBmId } = selfAccount

  const { isFormOpen } = useManageDrawer({
    formName: REQUEST_FACEBOOK_PAGE_ACCESS
  })

  const onAfterFormClose = useCallback(() => {
    dispatch(clearSelfAccount())
  }, [dispatch])

  useEffect(() => {
    if (isFormOpen && selectedPartnershipRightsHolderAccountId) {
      dispatch(getSelfAccount(selectedPartnershipRightsHolderAccountId))
    }
  }, [dispatch, isFormOpen, selectedPartnershipRightsHolderAccountId])

  if (!selectedPartnershipRightsHolderAccountId) {
    return null
  }

  return (
    <FormDrawerWrapper
      formName={REQUEST_FACEBOOK_PAGE_ACCESS}
      openButtonText="Request Page Access"
      title="Request Facebook page access"
      isFormLoading={!selfAccountWasLoaded}
      onAfterFormClose={onAfterFormClose}
      SkeletonFormComponent={SkeletonSingleSectionForm}
    >
      {facebookBmId ? <RequestPageAccessForm /> : <FacebookBusinessManagerMissingWarning />}
    </FormDrawerWrapper>
  )
}

export default RequestPageAccess
